import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import QuantitySelector from '~/components/Generic/QuantitySelector';
import { useCart } from '@chordcommerce/react-autonomy';
import { MAX_QUANTITY } from '~/utils/constants';

const CartQuantitySelector = ({ quantity, lineItemId, ...props }) => {
  const { modifyLineItem, removeFromCart } = useCart();
  const [isLoading, setIsLoading] = useState(false);

  const maxQuantity = Math.max(quantity, MAX_QUANTITY);
  const options = [
    { name: '0 - Remove', value: 0 },
    ...Array.from({ length: maxQuantity }).map((_, i) => ({
      name: String(i + 1),
      value: i + 1,
    })),
  ];

  const updateQuantity = async (quantity) => {
    setIsLoading(true);
    const intQuantity = parseInt(quantity);
    try {
      if (intQuantity === 0) {
        await removeFromCart({ lineItemId });
      } else {
        await modifyLineItem({ lineItemId, attributes: { quantity: intQuantity } });
      }
    } catch (error) {}
  };

  useEffect(() => setIsLoading(false), [quantity, lineItemId]);

  return (
    <QuantitySelector
      value={quantity}
      isLoading={isLoading}
      handleChange={updateQuantity}
      options={options}
      lineItemId={lineItemId}
      {...props}
    />
  );
};

CartQuantitySelector.propTypes = {
  lineItemId: PropTypes.number.isRequired,
  quantity: PropTypes.number.isRequired,
};

export default CartQuantitySelector;
